function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
export var ScrollSpy = /*#__PURE__*/function () {
  function ScrollSpy(menu) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ScrollSpy);
    if (!menu) {
      throw new Error('First argument is query selector to your navigation.');
    }
    if (_typeof(options) !== 'object') {
      throw new Error('Second argument must be instance of Object.');
    }
    var defaultOptions = {
      sectionClass: '.scrollspy',
      menuActiveTarget: 'li > a',
      offset: 0,
      hrefAttribute: 'href',
      activeClass: 'active',
      scrollContainer: '',
      smoothScroll: {}
    };
    options.smoothScroll = options.smoothScroll === true && {} || options.smoothScroll;
    this.menuList = menu instanceof HTMLElement ? menu : document.querySelector(menu);
    this.options = Object.assign({}, defaultOptions, options);
    if (this.options.scrollContainer) {
      this.scroller = this.options.scrollContainer instanceof HTMLElement ? this.options.scrollContainer : document.querySelector(this.options.scrollContainer);
    } else {
      this.scroller = window;
    }
    this.sections = document.querySelectorAll(this.options.sectionClass);
    this.attachEventListeners();
  }
  _createClass(ScrollSpy, [{
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var _this = this;
      if (this.scroller) {
        this.scroller.addEventListener('scroll', function () {
          return _this.onScroll();
        });

        // smooth scroll
        if (this.options.smoothScroll) {
          var menuItems = this.menuList.querySelectorAll(this.options.menuActiveTarget);
          menuItems.forEach(function (item) {
            return item.addEventListener('click', _this.onClick.bind(_this));
          });
        }
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var targetSelector = event.target.getAttribute(this.options.hrefAttribute);
      var targetElement = document.querySelector(targetSelector);
      if (targetElement && this.options.smoothScroll) {
        // prevent click event
        event.preventDefault();
        // handle smooth scrolling to 'targetElement'
        this.scrollTo(targetElement);
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var section = this.getSectionInView();
      var menuItem = this.getMenuItemBySection(section);
      if (menuItem) {
        this.removeCurrentActive({
          ignore: menuItem
        });
        this.setActive(menuItem);
      }
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(targetElement) {
      var smoothScrollBehavior = typeof this.options.smoothScrollBehavior === 'function' && this.options.smoothScrollBehavior;
      if (smoothScrollBehavior) {
        smoothScrollBehavior(targetElement, this.options.smoothScroll);
      } else {
        targetElement.scrollIntoView(_objectSpread(_objectSpread({}, this.options.smoothScroll), {}, {
          behavior: 'smooth'
        }));
      }
    }
  }, {
    key: "getMenuItemBySection",
    value: function getMenuItemBySection(section) {
      if (!section) return;
      var sectionId = section.getAttribute('id');
      return this.menuList.querySelector("[".concat(this.options.hrefAttribute, "=\"#").concat(sectionId, "\"]"));
    }
  }, {
    key: "getSectionInView",
    value: function getSectionInView() {
      for (var i = 0; i < this.sections.length; i++) {
        var startAt = this.sections[i].offsetTop;
        var endAt = startAt + this.sections[i].offsetHeight;
        var currentPosition = (document.documentElement.scrollTop || document.body.scrollTop) + this.options.offset;
        if (this.options.scrollContainer && this.scroller) {
          currentPosition = this.scroller.scrollTop + this.options.offset;
        }
        var isInView = currentPosition > startAt && currentPosition <= endAt;
        if (isInView) return this.sections[i];
      }
    }
  }, {
    key: "setActive",
    value: function setActive(activeItem) {
      var isActive = activeItem.classList.contains(this.options.activeClass);
      if (!isActive) activeItem.classList.add(this.options.activeClass);
    }
  }, {
    key: "removeCurrentActive",
    value: function removeCurrentActive(_ref) {
      var _this2 = this;
      var ignore = _ref.ignore;
      var _this$options = this.options,
        hrefAttribute = _this$options.hrefAttribute,
        menuActiveTarget = _this$options.menuActiveTarget,
        activeClass = _this$options.activeClass;
      var items = "".concat(menuActiveTarget, ".").concat(activeClass, ":not([").concat(hrefAttribute, "=\"").concat(ignore.getAttribute(hrefAttribute), "\"])");
      var menuItems = this.menuList.querySelectorAll(items);
      menuItems.forEach(function (item) {
        return item.classList.remove(_this2.options.activeClass);
      });
    }
  }]);
  return ScrollSpy;
}();